@use "variables" as *;

.buttonOAuth {
  display: flex;
  position: relative;
  width: 210px;
  height: 30px;
  min-height: 30px;
  background-color: white;
  border-radius: 15px;
  color: black;
  box-shadow: 0 3px 4px 0 rgba(0, 0, 0, 0.25);
  font-size: 14px;
  border: 1px solid lightgrey;
  font-weight: 500;
  cursor: pointer;
  .iconOAuth {
    width: 16px;
  }
  &:hover {
    color: #888888;
    transition: 0.3s;
    .iconOAuth {
      opacity: 0.6;
      transition: 0.3s;
    }
  }
}

.imageContainer {
  width: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: -14px;
}

.textContainer {
  display: flex;
  flex-grow: 1;
  align-items: center;
  justify-content: center;
  font-size: $fontSize-sm;
  font-weight: bold;
}
